import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { connect } from 'react-redux';
import { Tab, Nav, Row, Col, NavItem, NavDropdown, MenuItem, Alert } from 'react-bootstrap';
import { ClientDetails, ClientContacts, JobList, JobView } from './';
import * as Actions from 'actions';
import * as Permissions from 'permissions';

class ClientJobs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      preview_open : false,
      deleting: false,
    }
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentWillMount() {
    this.props.fetchJobsFilters();
    this.props.fetchJobs({ client: this.props.client._id });
  }
  componentDidMount() {
    const resize = f => {
      const window_height = $(window).height();
      const offset = $(this.refs.jobsContainer).offset().top;
      $(this.refs.jobsContainer).height(window_height - offset);
    }
    $(window).on('resize.jobs-container',resize);
    resize();
  }
  componentWillUnmount() {
    $(window).off('resize.jobs-container');
  }
  handleScroll(event) {
    const total = event.target.scrollHeight;
    const to_top  = event.target.scrollTop;
    const height = event.target.clientHeight;
    const current = to_top + height;
    if(current + 50 >= total && !this.props.downloading_jobs && this.props.downloaded_jobs.length < this.props.total) {
      this.props.fetchNextJobs(this.props.client._id);
    }
  }
  render() {
    const job_container = this.props.downloaded_jobs.find(({job}) => job._id == this.props.previewing_job);
    const client = job_container ? job_container.job.client : undefined;
    const { deleting } = this.state;
    const { job } = job_container || {};

    if(!this.props.hasPermission(Permissions.VIEW_OPPORTUNITIES)) {
      return <Alert>
        <h3>Sorry!</h3>
        <p>You do not currently have permission to view opportunities. Please contact us to gain access.</p>
      </Alert>
    }
    return (
      <div ref="jobsContainer" className="client-jobs jobs-container">
        <div className="job-list-container">
          <div className="container-title clearfix">
            <div onClick={e => this.props.startCreatingJob()} className="pull-right btn btn-default"><i className="fa fa-plus"></i></div>
            <h3 className="pull-left">Opportunities {this.props.downloading_jobs ? <i className="fa fa-spinner fa-spin"></i> : ''}</h3>
          </div>
 	          <div onScroll={this.handleScroll.bind(this)} className="container-content">
            <JobList onSelect={job_container => {
              this.props.previewJob(job_container.job._id)
              this.setState({ preview_open : true });
            }} />
          </div>
        </div>
        <div className={`job-preview-container${this.state.preview_open ? ' animated fadeInRight open' : ' closed fadeOutRight'}`}>
        	{(() => {
        		if(job_container) {
        			return (
        				<div className="container-title clearfix">
		              <a onClick={e => {
		                e.preventDefault();
		                this.setState({ preview_open : !this.state.preview_open})
		              }} href="#" className="animated fadeIn pull-right close-button">x</a>
		              <h3 className="pull-left mr-lg"><i className={`fa fa-${job.status == 'Lead' ? 'address-card-o' : 'handshake-o'}`} /> {job_container.job.client.name}</h3>
                  {deleting ? (
                    <div className="btn-group animated fadeInLeft">
                      <div onClick={e => this.setState({deleting: false})} className="btn btn-default"><i className="fa fa-close"></i></div>
                      <div onClick={e => this.props.deleteJob(job_container.job)} className="btn btn-danger"><i className="fa fa-trash"></i> Are you sure?</div>
                    </div>
                  ) : (
                    <div onClick={e => {
                      this.setState({deleting: true});
                    }} className="btn btn-danger pull-left"><i className="fa fa-trash"></i></div>
                  )}
		            </div>
        				)
        		}
        	})()}
          <div className="container-content">
            {!job_container ? <h3 className="text-center">Please Select an Opportunity</h3> : ''}
            <JobView {...((job_container) || {})} client={client} />
          </div>
        </div>
      </div>
    );
  }
}

ClientJobs.propTypes = {
  client : PropTypes.object
}

const mapStateToProps = ({ client, jobs }) => ({ client, ...jobs });

export default connect(mapStateToProps, Actions)(ClientJobs);



// WEBPACK FOOTER //
// ./src/browser/components/client/client-jobs.js